module.exports = __webpack_public_path__ + "img/esp-sertifikat-2.ac0eee2a.jpg";